import { defineField } from '@/form/useForm'
import { match } from '@/utils/etc'
import { EAssetSource, EAssetType, type IProviderImport } from 'findef'
import { lockedByIr, lockedByProvider } from '../toolips'
import type { UseAssetFormComputedData, UseAssetFormState } from '../types'

export const quantityField = () => {
  return defineField<UseAssetFormState, number, UseAssetFormComputedData>({
    type: 'number',
    label: 'I Own',
    value: 0,
    placeholder: '0',
    display: { value: 'Shares' },
    needs: ['asset.type', 'asset.source', 'providerImport', 'ownershipPercentage'],
    next: (state) => {
      const providerImport = state.asset.providerImport as IProviderImport | null | undefined

      return {
        value: state.asset.type === EAssetType.CASH
          ? 1
          : state.asset.type === EAssetType.REAL_ESTATE
            ? (state.ownershipPercentage || 0) / 100
            : state.quantity,
        locked: state.asset.source === EAssetSource.IR || !!providerImport,
        ...(state.asset.source === EAssetSource.IR
          ? lockedByIr(state)
          : providerImport
            ? lockedByProvider(state)
            : {
                lockedReason: 'This field is maintained by another source'
              }),
        display: {
          value: match(
            state.asset.type,
            [
              [EAssetType.REAL_ESTATE, '%'],
              [EAssetType.CRYPTO, 'Coins'],
              [EAssetType.ALTERNATIVE, 'Units'],
              [EAssetType.COMMODITY, 'Units']
            ],
            'Shares'
          )
        }
      }
    }
  })
}
